var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _rect, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _rect2, _path44, _path45, _path46, _path47, _path48, _rect3;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGirlCallDesk(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 131,
    viewBox: "0 0 206 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5558 55.6403H44.5209",
    stroke: "#D6E3F8",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.0377 11.7693C68.0377 10.566 67.0602 9.58984 65.8539 9.58984C64.6502 9.58984 63.6728 10.566 63.6728 11.7693C63.6728 12.9734 64.6502 13.9489 65.8539 13.9489C67.0602 13.9489 68.0377 12.9734 68.0377 11.7693Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M162.026 17.4215H194.083",
    stroke: "#E8F0FC",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.05 138.602H70.5225L58.2545 63.1957C57.2712 57.6852 52.4751 53.6729 46.8717 53.6729H5.75943L22.331 154.139H133.831C133.831 145.558 127.661 138.602 120.05 138.602Z",
    fill: "#BAD0F7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.1269 138.602H36.1235L23.8569 63.1957C22.8743 57.6852 18.0775 53.6729 12.4729 53.6729H3.31573L20.0054 154.139H99.9073C99.9073 145.558 93.7378 138.602 86.1269 138.602Z",
    fill: "#D6E3F8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.9061 154.14H22.3283L5.75729 53.6748H0L16.4243 153.245V216.816H21.527V159.888H94.8038V216.816H99.9061V154.14Z",
    fill: "#E8F0FC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.462 99.5156L145.526 217H153.269L172.609 99.5156H164.462V99.5156Z",
    fill: "#BAD0F7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.673 99.5156H178.917L198.258 217H204.015L184.673 99.5156V99.5156Z",
    fill: "#BAD0F7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.063 99.5156H181.554L200.896 217H205.998L187.063 99.5156V99.5156Z",
    fill: "#E8F0FC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.558 99.5156L184.298 116.159L188.993 111.469L187.066 99.5156H181.558L181.558 99.5156Z",
    fill: "#D6E3F8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4573 25.2217C82.3207 26.5256 83.5407 28.6861 83.5407 31.1322C83.5407 31.7056 83.4735 32.2632 83.347 32.7982",
    stroke: "black",
    strokeWidth: 0.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.4524 32.7982C84.4524 32.1636 83.9376 31.6494 83.3015 31.6494C82.668 31.6494 82.1533 32.1636 82.1533 32.7982C82.1533 33.4329 82.668 33.9463 83.3015 33.9463C83.9376 33.9463 84.4524 33.4329 84.4524 32.7982Z",
    fill: "#111111"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.2049 0V1.21647H68.594C72.6966 1.21647 76.0233 4.53889 76.0233 8.636V23.4594H80.6694V11.2854C80.6694 5.05306 75.6098 0 69.3677 0H67.2049H67.2049Z",
    fill: "#D6E3F8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.1406 1.2207H67.2922C74.2369 1.2207 76.0235 5.18943 76.0235 10.0234V23.459H79.8708V11.9378C79.8708 6.01887 75.0675 1.2207 69.1406 1.2207Z",
    fill: "#BAD0F7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.654 17.2959H76.0803C72.9621 17.2959 70.434 19.8208 70.434 22.934C70.434 26.0486 72.9621 28.5734 76.0803 28.5734H77.654C80.7714 28.5734 83.299 26.0486 83.299 22.934C83.299 19.8208 80.7714 17.2959 77.654 17.2959Z",
    fill: "#D6E3F8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.2386 121.413C77.8607 110.94 86.6375 102.44 97.1081 103.139L142.756 106.187C150.914 106.715 155.782 112.546 157.58 120.509L175.338 199.093H143.439L124.949 138.453H95.9265C86.4001 138.453 78.5804 130.922 78.2386 121.413Z",
    fill: "#090F25"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.5528 33.738C64.3133 39.8641 61.5789 47.068 55.4438 49.8242C49.3069 52.5828 42.096 49.8509 39.3335 43.7234C36.5736 37.5972 39.3073 30.3941 45.4443 27.6373L56.553 22.6436L61.5528 33.738Z",
    fill: "#111111"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.86 82.8878L93.6707 78.4804L83.8303 51.8629C82.0948 47.1292 77.2621 45.1784 72.6505 46.7167C67.8628 48.3138 64.7494 53.9232 66.4842 58.657C66.5462 58.8251 66.6239 59.0159 66.693 59.1782L80.0951 88.7677L80.3827 89.4212C81.6166 92.2399 84.3979 93.9047 87.2942 93.8695H122.174C125.562 93.8232 127.402 92.2784 127.357 88.8967C127.312 85.7566 124.913 83.2018 121.86 82.8878Z",
    fill: "#D7CEE0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.0168 46.1994C43.2219 47.6309 39.7052 51.7241 39.7149 57.9225C39.7404 72.9224 43.3544 86.4747 47.7349 96.6216C49.8742 101.572 75.8281 99.5159 77.5317 96.0965C84.6643 81.7858 85.4291 66.0079 83.619 52.5509C83.2309 49.6585 81.8209 45.6428 76.765 44.7685C65.0359 42.7375 61.2256 42.254 48.0168 46.1994Z",
    fill: "#EEE9F2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.6037 64.3054L46.9848 93.0654H69.23L46.0772 58.2451L43.6037 64.3054H43.6037Z",
    fill: "#D7CEE0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.606 104.801L83.4267 102.234C77.8651 94.9539 69.0407 89.8866 59.8719 91.0555C45.6588 92.8689 36.0084 108.964 37.6936 122.142C39.3784 135.322 51.7618 140.594 65.9729 138.781C66.2013 138.752 66.4251 138.717 66.6495 138.684L66.6756 138.781L103.201 138.583L94.656 199.092H130.273L135.916 122.381C136.621 111.423 130.785 105.332 122.606 104.801Z",
    fill: "#18203B"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.8768 55.431C61.215 55.0341 57.7604 50.9384 58.1576 46.2835L60.4387 32.0693L75.6094 33.0161L74.6693 47.5905C74.2706 52.2442 70.538 55.8278 65.8768 55.431Z",
    fill: "#EEE9F2"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4869 44.5469L68.1274 53.1228C74.7354 62.8568 75.0191 82.1395 69.5901 98.9345",
    stroke: "black",
    strokeWidth: 0.2
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.9271 44.5641C65.2434 44.5641 59.3909 40.6365 59.7387 36.566L60.4643 27.543L75.9509 28.8018L75.224 37.823C74.8769 41.8934 73.6124 44.5641 68.9271 44.5641Z",
    fill: "#FEB991"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.4098 41.7946C64.857 41.0862 60.2669 34.0726 60.6153 30.0029L60.9462 24.7734L76.4334 26.0317L75.7059 35.0539C75.3589 39.1237 74.0389 42.5152 69.4098 41.7946Z",
    fill: "#FB9B73"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.7875 19.772L60.8892 32.5319C63.1133 38.0905 69.4257 40.7979 74.9925 38.5773C79.3926 36.8226 82.0043 32.4948 81.808 28.021L81.1837 14.2957C80.8528 7.03641 74.6931 1.41976 67.4247 1.75019C60.1551 2.07984 54.5309 8.2313 54.8624 15.4905C54.9302 16.9827 55.2683 18.4553 55.7875 19.772Z",
    fill: "#FEB991"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.2401 25.5052C50.2742 18.5999 51.8539 8.98197 58.7673 4.02211C65.6825 -0.937746 75.3141 0.639175 80.2799 7.54454C78.1587 16.6353 65.0419 16.1995 59.7231 16.1995C59.2566 16.1995 60.1739 23.1779 59.7231 23.2671C57.9831 23.6106 56.8849 25.5346 55.2401 25.5052Z",
    fill: "#111111"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.522 14.79C61.522 14.79 62.8172 27.6906 56.6705 29.1769C54.8489 19.067 55.4888 16.1082 55.4888 16.1082L61.522 14.79Z",
    fill: "#111111"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.6464 20.8097L60.5639 25.4099C60.7909 26.5455 59.8533 27.5757 58.6999 27.4675C56.2081 27.2335 54.301 25.7232 53.8749 23.5913C53.3281 20.85 54.5997 18.2887 56.7143 17.8679C58.8283 17.4469 59.3724 19.4368 59.6464 20.8097Z",
    fill: "#FEB991"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.7336 47.7212C50.3204 45.6204 55.7455 47.6325 57.8477 52.2138L70.0447 78.7825L99.3684 83.2354C102.421 83.5494 103.803 85.0865 103.845 88.2257C103.892 91.6074 102.203 94.0039 98.8152 94.0502L64.2007 94.5206C61.5288 94.5519 58.9243 93.1282 57.5854 90.6093L41.4704 60.2959C41.3929 60.1486 41.3048 59.9727 41.2343 59.8196C39.1315 55.2383 41.1455 49.8212 45.7336 47.7212Z",
    fill: "#EEE9F2"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0219 102.535C70.4994 102.669 71.4879 102.923 71.4879 102.923",
    stroke: "black",
    strokeWidth: 0.2
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.627 91.5232L139.843 86.6643C139.84 86.6611 139.837 86.6592 139.835 86.6559C139.665 86.4037 139.44 86.1874 139.168 86.0355L133.658 82.2532C132.949 81.8577 132.097 81.846 131.379 82.2232C130.805 82.5248 130.391 83.039 130.207 83.6444L129.194 83.2135C128.473 82.9837 127.694 83.1302 127.108 83.6078C126.571 84.0438 126.289 84.6952 126.304 85.3788L126.182 85.3742C125.486 85.4193 124.868 85.8063 124.527 86.4115C124.185 87.0168 124.174 87.746 124.495 88.3617C124.627 88.6152 124.807 88.8308 125.019 89.0028C125.485 89.3802 126.103 89.5469 126.692 89.4225L130.159 89.1769C130.691 90.274 131.415 91.7479 131.833 92.5071C132.547 93.8057 133.632 93.8388 134.047 93.6721C134.691 93.4141 134.541 92.8981 134.459 92.1722L133.824 89.9353C134.595 90.9446 135.546 92.1695 136.099 92.8211C137.142 94.0499 138.304 93.8512 138.71 93.5835C139.34 93.1697 139.069 92.6524 138.824 91.8972L138.153 90.6038C139.128 91.4802 140.265 92.4882 140.932 93.0316C142.273 94.1256 143.461 93.6878 143.837 93.3261C144.421 92.7658 144.034 92.2718 143.627 91.5232Z",
    fill: "#FB9B73"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.692 91.5226L142.575 86.2779C142.533 86.2232 142.479 86.1822 142.432 86.1314C142.242 85.8909 142.001 85.6954 141.721 85.5633C141.622 85.5092 141.521 85.4726 141.42 85.4335L133.872 82.2512C133.805 82.2193 133.742 82.1841 133.672 82.1542C132.98 81.8584 132.264 81.6668 131.496 81.7763L121.565 83.5975C119.056 83.9557 117.19 86.1034 117.19 88.6354V88.6361C117.19 91.447 120.131 93.8271 122.946 93.8271H122.972L122.946 93.8701H136.589C140.124 93.8701 137.901 90.6065 135.149 90.1783C133.965 89.994 132.344 89.8343 130.779 89.7073C131.911 88.8042 132.964 87.909 133.765 87.1915L139.735 89.1892C140.829 90.2084 143.011 92.2289 143.997 93.031C145.339 94.125 146.526 93.6872 146.903 93.3255C147.487 92.7652 147.099 92.2712 146.692 91.5226Z",
    fill: "#FEB991"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 122.482,
    y: 90.1777,
    width: 40.6986,
    height: 3.54651,
    fill: "#BAD0F7"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.833 93.7249C127.777 93.7249 128.308 92.6159 127.696 91.8959C124.967 88.6752 120.89 86.6299 116.333 86.6299C111.777 86.6299 107.699 88.6752 104.968 91.8959C104.359 92.6159 104.889 93.7249 105.833 93.7249H126.833Z",
    fill: "#D6E3F8"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.733 91.5229L120.616 86.2782C120.573 86.2235 120.519 86.1825 120.472 86.1317C120.282 85.8912 120.041 85.6957 119.761 85.5636C119.663 85.5095 119.562 85.4729 119.46 85.4338L111.788 82.2C111.761 82.1858 111.739 82.1681 111.712 82.1545C111.04 81.8169 110.304 81.6671 109.536 81.7766L96.147 83.5978C93.6371 83.956 91.771 86.1037 91.771 88.6357V88.6364C91.771 91.4473 94.711 93.8274 97.5269 93.8274H102.146C103.594 93.8274 106.987 92.2832 109.865 90.8321C110.189 91.4838 110.502 92.0988 110.726 92.5068C111.44 93.8054 112.525 93.8385 112.941 93.6718C113.584 93.4138 113.436 92.8978 113.353 92.1718L112.788 90.1897C113.521 91.143 114.363 92.2233 114.87 92.8208C115.912 94.0496 117.075 93.8509 117.482 93.5832C118.111 93.1694 117.84 92.6521 117.596 91.8969L117.551 91.8122C118.097 92.2924 118.606 92.7328 118.973 93.0313C120.314 94.1253 121.502 93.6875 121.879 93.3258C121.972 93.2365 122.032 93.1486 122.081 93.0612C123.404 94.1103 124.57 93.6828 124.942 93.3258C125.526 92.7655 125.139 92.2715 124.733 91.5229Z",
    fill: "#FEB991"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M122.176 92.2172L118.653 86.8744L115.19 84.6094",
    stroke: "#FB9B73",
    strokeWidth: 0.2
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M117.596 91.8964L114.515 85.9071L109.731 83.8096",
    stroke: "#FB9B73",
    strokeWidth: 0.2
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M113.072 90.5545L111.907 87.1337C111.596 86.2516 110.742 85.6794 109.807 85.7263L106.237 85.9055",
    stroke: "#FB9B73",
    strokeWidth: 0.2
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.768 74.672H188.673C189.52 74.672 190.297 73.9854 190.405 73.1383L197.503 17.7986C197.612 16.9515 197.011 16.2646 196.163 16.2646H117.257C116.41 16.2646 115.634 16.9515 115.526 17.7986L108.427 73.1383C108.319 73.9854 108.92 74.672 109.768 74.672Z",
    fill: "#BAD0F7"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.228 74.672H190.134C190.981 74.672 191.757 73.9854 191.866 73.1383L198.964 17.7986C199.072 16.9515 198.472 16.2646 197.623 16.2646H118.718C117.87 16.2646 117.095 16.9515 116.986 17.7986L109.888 73.1383C109.78 73.9854 110.38 74.672 111.228 74.672Z",
    fill: "#D6E3F8"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.623 16.2637H189.119C169.623 35.7328 150.128 55.2019 130.632 74.671H190.134C190.981 74.671 191.757 73.9842 191.865 73.1365L198.963 17.7974C199.072 16.9505 198.471 16.2637 197.623 16.2637Z",
    fill: "#BAD0F7"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.875 90.1065H142.909V55.8174L143.481 52.3684C143.904 49.8254 146.106 47.96 148.687 47.96H156.597C159.512 47.96 161.875 50.3199 161.875 53.2312V90.1065Z",
    fill: "#BAD0F7"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.181 90.1065H144.214V52.5229C144.214 50.0032 146.258 47.96 148.783 47.96H158.612C161.134 47.96 163.181 50.0032 163.181 52.5229V90.1065Z",
    fill: "#D6E3F8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 133.83,
    y: 92.2158,
    width: 39.7285,
    height: 1.54939,
    fill: "#BAD0F7"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.559 92.2168C160.316 88.2246 147.073 88.2246 133.83 92.2168H173.559Z",
    fill: "#D6E3F8"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.3255 28.5725C60.4428 28.5725 62.9711 26.0476 62.9711 22.9344C62.9711 19.8198 60.4428 17.2949 57.3255 17.2949H55.7517V28.5725H57.3255Z",
    fill: "#BAD0F7"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.3994 22.9346C61.3994 19.8208 58.8711 17.2959 55.7532 17.2959C52.6338 17.2959 50.1061 19.8208 50.1061 22.9346C50.1061 26.0486 52.6338 28.5734 55.7532 28.5734C58.8711 28.5734 61.3994 26.0486 61.3994 22.9346Z",
    fill: "#D6E3F8"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.632 22.9342C58.632 21.3457 57.342 20.0576 55.752 20.0576C54.1606 20.0576 52.872 21.3457 52.872 22.9342C52.872 24.5228 54.1606 25.8109 55.752 25.8109C57.342 25.8109 58.632 24.5228 58.632 22.9342Z",
    fill: "#BAD0F7"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.3185 0H64.7296C58.4895 0 53.4298 5.05306 53.4298 11.2854V22.4424C53.4298 23.7232 54.4704 24.7625 55.7519 24.7625C57.0353 24.7625 58.0758 23.7232 58.0758 22.4424V10.0239C58.0758 5.15924 62.0245 1.13578 66.8944 1.13578H67.3185V0Z",
    fill: "#D6E3F8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 33.3784,
    y: 93.7666,
    width: 172.622,
    height: 5.74754,
    fill: "#E8F0FC"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGirlCallDesk);
export default __webpack_public_path__ + "static/media/girl-call-desk.87c2066dbc0179983780d9ad9d4559e7.svg";
export { ForwardRef as ReactComponent };